import { z } from "zod";

export const clienteSchema = z.object({
  nome: z.string().min(1, "Nome é obrigatório"),
  cpf_cnpj: z.string().optional(),
  telefone: z.string().optional(),
  email: z.string().email("Email inválido").optional().or(z.literal("")),
  endereco: z.string().optional(),
  data_nascimento: z.string().optional(),
  observacoes: z.string().optional(),
  ativo: z.boolean().default(true),
});

export type ClienteFormData = z.infer<typeof clienteSchema>;
